import CheckoutContainer from "./CheckoutContainer";
import CheckoutHeader from "./CheckoutHeader";
import ProductPreview from "./ProductPreview";
import PropTypes from "prop-types";
import React from "react";

const BuyItNow = ({
  contactFromSession,
  productDescriptor,
  recaptchaSiteKey
}) => {
  const {
    "id": productDescriptorId,
    "retail_price": retailPrice
  } = productDescriptor;

  return (
    <div id="buy-it-now">
      <CheckoutHeader />
      <ProductPreview productDescriptor={productDescriptor} />
      <CheckoutContainer
        contactFromSession={contactFromSession}
        productDescriptorId={productDescriptorId}
        recaptchaSiteKey={recaptchaSiteKey}
        retailPrice={retailPrice}
      />
    </div>
  );
};

export default BuyItNow;

BuyItNow.defaultProps = {
  "contactFromSession": {},
  "recaptchaSiteKey": ""
};

BuyItNow.propTypes = {
  "contactFromSession": PropTypes.object,
  "productDescriptor": PropTypes.object.isRequired,
  "recaptchaSiteKey": PropTypes.string
};
